import { Component, Input, OnInit } from '@angular/core';
import { MobileService } from '@service/mobile.service';

@Component({
  selector: 'headline',
  templateUrl: './headline.component.html',
  styleUrls: ['./headline.component.scss'],
})
export class HeadlineComponent implements OnInit {
  @Input()
  public headlineText: string = '';

  @Input()
  public headlineDescription: string = '';

  constructor(public mobileService: MobileService) {}

  ngOnInit(): void {}

  public boldFirstWord(text: string): string {
    const words = text.split(' ');

    if (words.length > 0) {
      words[0] = `<strong>${words[0]}</strong>`;
    }

    return words.join(' ');
  }
}
